import axios from "axios";

function getData(data) {
    return axios.post('api/asociado/dataTable', data);
}

function selectAsociados() {
    return axios.get('api/asociado/selectAsociados');
}

function guardarAsociado(data) {
    return axios.post('api/asociado/guardarAsociado', data);
}

function editarAsociado(data) {
    return axios.put('api/asociado/editarrAsociado', data);
}

export {
    getData,
    selectAsociados,
    guardarAsociado,
    editarAsociado
}
